import PrepaidPlansList from './PrepaidPlansList';
export default PrepaidPlansList;
